const THREE = window.THREE;

function loadTexure( uri, onload)
{
    let loader = new THREE.TextureLoader()
    // loader.crossOrigin = 'Anonymous'
    return loader.load(uri, onload);
}

export default class MatProps{
    constructor(obj)
    {
        this._obj = obj;
        this.model = "";
    }
    
    get color(){
        let c = this._obj.color;
        return {rgba:{r: Math.floor(c.r * 255), g:Math.floor( c.g*255), b: Math.floor(c.b*255), a: Math.floor(1*255) }};
    }
    set color( v ) {
        let c = this._obj.color;
        c.setRGB( v.rgba.r / 255.0, v.rgba.g / 255.0, v.rgba.b / 255.0);
    }
    get emissive(){
        let c = this._obj.emissive;
        return {rgba:{r: Math.floor(c.r * 255), g:Math.floor( c.g*255), b: Math.floor(c.b*255), a: Math.floor(1*255) }};
    }
    set emissive( v ){
        let c = this._obj.emissive;
        c.setRGB( v.rgba.r / 255.0, v.rgba.g / 255.0, v.rgba.b / 255.0);
    }
    get roughness() {
        return this._obj.roughness;
    }
    set roughness(v) {
        this._obj.roughness = v;
    }
    
    get roughnessMap(){
        return this.getMapImage("roughnessMap");
    }
    set roughnessMap(v){
        this.setMapImage('roughnessMap', v);
    }

    get metalness(){
        return  this._obj.metalness;
    }
    set metalness(v){
        this._obj.metalness = v;
    }
    get transparent(){
        return this._obj.transparent;
    }
    set transparent(v){
        this._obj.transparent = v;
    }
    get opacity(){
        return this._obj.opacity;
    }
    set opacity( v ) {
        this._obj.opacity = v;
    }
    get alphaTest(){
        return this._obj.alphaTest;
    }
    set alphaTest( v ) {
        this._obj.alphaTest = v;
    }
    get side() {
        return this._obj.side;
    }
    set side( v ) {
        this._obj.side = v;
    }
    
    getMapImage(name)
    {
        let t = this._obj[name];

        if( t && t.image)   {
            let src = t.image.src;
            return src;
        }   
        return "";
    }
    
    setMapImage(name, url)
    {
        if( !url ) {
            this._obj[name] = null;
            this._obj.needsUpdate = true;
            return;
        }
        let obj = this._obj;

        this._obj[name] = loadTexure( url , function(){
            obj.needsUpdate = true;
        });
    }

    get metalnessMap(){
        return this.getMapImage("metalnessMap");
    }
    set metalnessMap(v){
        this.setMapImage('metalnessMap', v);
    }
    
    get emissiveMap(){
        return this.getMapImage("emissiveMap");
    }
    set emissiveMap(v){
        this.setMapImage('emissiveMap', v);
    }
    get emissiveIntensity(){
        return this._obj.emissiveIntensity;
    }

    set emissiveIntensity( v ) {
        this._obj.emissiveIntensity = v;
    }

    get map(){
        return this.getMapImage('map');
    }
    set map( v ) {
        this.setMapImage('map', v);
    }
    get alphaMap()
    {
        return this.getMapImage('alphaMap');
    }
    set alphaMap( v ){
        this.setMapImage('alphaMap', v);
    }

    get aoMap()
    {
        return this.getMapImage('aoMap');
    }
    set aoMap( v ){
        this.setMapImage('aoMap', v);
    }
    get aoMapIntensity(){
        return this._obj.aoMapIntensity;
    }
    set aoMapIntensity(v){
        this._obj.aoMapIntensity = v;
    }


    get bumpScale() {
        return this._obj.bumpScale;
    }
    set bumpScale( v ) {
        this._obj.bumpScale = v;
    }    
    get bumpMap()
    {
        return this.getMapImage('bumpMap');
    }
    set bumpMap( v ){
        this.setMapImage('bumpMap', v);
    }

    get displacementMap()
    {
        return this.getMapImage('displacementMap');
    }
    set displacementMap( v ){
        this.setMapImage('displacementMap', v);
    }

    get envMapIntensity(){
        return this._obj.envMapIntensity;
    }
    set envMapIntensity( v ) {
        this._obj.envMapIntensity = v;
    }
    get normalMap()
    {
        return this.getMapImage('normalMap');
    }
    set normalMap( v ){
        this.setMapImage('normalMap', v);
    }

    get normalScale(){
        return this._obj.normalScale;
    }
    set normalScale( v ) {
        this._obj.normalScale.set(v.x, v.y);
    }
    get displacementMap()
    {
        return this.getMapImage('displacementMap');
    }
    set displacementMap( v ){
        this.setMapImage('displacementMap', v);
    }
    get displacementScale(){
        return this._obj.displacementScale;
    }
    set displacementScale( v ){
        this._obj.displacementScale = v;
    }

    get displacementBias(){
        return this._obj.displacementBias;
    }
    set displacementBias( v ) {
        this._obj.displacementBias = v;
    }
    get lightMap()
    {
        return this.getMapImage('lightMap');
    }
    set lightMap( v ){
        this.setMapImage('lightMap', v);
    }

    get lightMapIntensity(){
        return this._obj.lightMapIntensity;
    }
    set lightMapIntensity( v ) {
        this._obj.lightMapIntensity = v;
    }

    setJson( json ) {
        for (let name in json) {
            let v = json[name];

            if( v && typeof v == 'string' && v.indexOf('blob:') == 0) { 
                continue;
            }
            this[name] = json[name];
        }
    }

    json() {
        return {
            name: this.name,
            roughness: this.roughness,
            metalness: this.metalness,
            color: { rgba:{ ...this.color.rgba} },
            emissive:{rgba:{ ...this.emissive.rgba }},
            transparent: this.transparent,
            opacity:this.opacity,
            alphaTest: this.alphaTest,
            side:this.side,
            map: this.map,
            roughnessMap: this.roughnessMap,
            metalnessMap: this.metalnessMap,
            emissiveMap:this.emissiveMap,
            emissiveIntensity: this.emissiveIntensity,
            alphaMap:this.alphaMap,

            aoMap:this.aoMap,
            aoMapIntensity:this.aoMapIntensity,

            bumpMap: this.bumpMap,
            bumpScale: this.bumpScale,
            envMapIntensity: this.envMapIntensity,

            normalMap: this.normalMap,
            normalScale:{ ...this.normalScale },

            lightMap: this.lightMap,
            lightMapIntensity: this.lightMapIntensity,

            displacementMap: this.displacementMap,
            displacementScale: this.displacementScale,
            displacementBias: this.displacementBias,
        }
    }
}